import * as React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { useParams } from 'react-router-dom';
import {
    CircularProgress, makeStyles,
} from '@material-ui/core';

import * as AuthStore from '../../app/store/AuthStore';
import Auth from '../../youwell-common/Auth';
import urls from '../../app/urls';
import { storeLanguagePreferance } from '../../app/localization';

const useStyles = makeStyles(theme => ({
    root: {
    },

    login_container: {
        padding: theme.spacing(2),
    },

    loginBox: {
        margin: theme.spacing(2, 0),
        position: 'relative',
    },
    loginButtons: {
        margin: theme.spacing(4, 0),
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
    },
    loginButton: {
        flex: '0 0 calc(66% - 16px)',
        margin: theme.spacing(2, 1),
    },

    loading: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, 0)',
    },
    infoContainer: {
        marginTop: theme.spacing(4),
        color: theme.youwell.colors.secondary,
    },
}), { name: 'GoToCountry' });


const GoToCountry = ({ setActiveLanguage }) => {
    const classes = useStyles();
    const params = useParams();
    const dispatch = useDispatch();
    const appConfig = useSelector(state => state.pageSettings.appConfig);
    const redirect = params.redirect ? decodeURIComponent(params.redirect) : urls.inside.home;

    React.useEffect(() => {
        const language = appConfig?.language;
        const programId = appConfig?.startProgram?.[language];
        setActiveLanguage(language);
        storeLanguagePreferance(language);
        const isLoggedIn = Auth.isUserAuthenticated();

        if (isLoggedIn) {
            dispatch(AuthStore.actionCreators.getUserProfile({ redirect, programId }));
        } else {
            dispatch(AuthStore.actionCreators.startNewSession({
                orgId: appConfig?.orgId,
                programId,
                programStartDate: new Date(),
                includeCurrentProgramInResponse: true,
            }, { redirect, useSessionWithoutLifetime: true }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={classes.root}>
            <div className={classes.login_container}>
                <div className={classes.loginBox}>
                    <div className={classes.loading}>
                        <CircularProgress />
                    </div>
                </div>
            </div>
        </div>
    );
};

GoToCountry.propTypes = {
    setActiveLanguage: PropTypes.func.isRequired,
};

export default withLocalize(GoToCountry);
